module.exports = __webpack_public_path__ + "ev-close.svg?d11828fda8d740a71fd93b3f02fa2def";